import script from "./Hold.vue?vue&type=script&setup=true&lang=js"
export * from "./Hold.vue?vue&type=script&setup=true&lang=js"

import "./Hold.vue?vue&type=style&index=0&id=0b10a9d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b10a9d8"]])

export default __exports__